export class Rota {
  descricao = null;

  constructor(rota) {
    this.descricao = rota.descricao;
  }
}
